export const KNOWLEDGE_BASE_URL = {
  componentSeller: 'https://docs.prebid.org/dev-docs/modules/paapi.html#componentSeller',
  paapiForGpt: 'https://docs.prebid.org/dev-docs/modules/paapiForGpt.html',
  parallel: 'https://docs.prebid.org/dev-docs/modules/paapi.html#parallel',
} as const
